
export default function Footer() {
  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img
              src="https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/efb126a658386e4be9bce47e295892e3.png"
              alt="ATENA"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              神戸三宮で最高級のおもてなしを提供するホストクラブです。
              特別な夜をお約束いたします。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                <i className="ri-tiktok-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                <i className="ri-line-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">店舗情報</h4>
            <div className="space-y-2 text-gray-400">
              <p className="flex items-center">
                <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                〒650-0004 神戸市中央区中山手通1丁目4-15 コーストテラス東門ビル6階・7階
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line text-blue-500 mr-2"></i>
                078-954-6898
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">営業時間</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>営業時間: 20:00 - 01:00</p>
              <p>定休日: 毎月1日、水曜、土曜</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 ATENA. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}